export default __webpack_public_path__ + "static/Plots0013-e3116bb87374025304889659a400f9f4.jpg";